import React, { Component } from 'react'

import setup from '../../../module/setup'
import LandingPage from '../../LandingPage/LandingPage'

export default class MyDashboardScene extends Component {
  render() {
    const { history } = this.props
    const goToMyDashboard = () => {
      history.push(`/${setup.myDashboard.path}`)
    }
    return <LandingPage goToMyDashboard={goToMyDashboard} />
  }
}



// WEBPACK FOOTER //
// ./src/component/_scenes/Scene/LandingPage.jsx